import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { ReactElement, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { businessSmallBossMachineOwnerQuery } from '@/__generated__/businessSmallBossMachineOwnerQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { SmallBossMachineOwnerContainer } from '@/components/survey/business/small-boss-machine-owner/SmallBossMachineOwnerContainer';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { smallBossMachineOwnerQuery } from '@/graphql/query/survey/business';
import { currentBusinessBmanTinAtom, refundHistoryIdAtom } from '@/lib/stores/survey/common';

function SmallBossMachineOwnerPage() {
  const [queryRef, loadQuery] = useQueryLoader<businessSmallBossMachineOwnerQuery>(smallBossMachineOwnerQuery);
  const refundHistoryId = useAtomValue(refundHistoryIdAtom);
  const bmanTin = useAtomValue(currentBusinessBmanTinAtom);
  const eventAttributes = useSurveyUserEventAttributes();

  useEffect(() => {
    if (refundHistoryId && bmanTin) {
      loadQuery(
        {
          refundHistoryId,
          bmanTin
        },
        { fetchPolicy: 'network-only' }
      );
    }
  }, [bmanTin, loadQuery, refundHistoryId]);

  if (!queryRef) return <Spinner />;
  return (
    <PageViewEventLogger pageName={'survey_small-boss-machine-owner'} eventProperty={eventAttributes}>
      <SmallBossMachineOwnerContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

SmallBossMachineOwnerPage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>{page}</BusinessProvider>
  </SurveyProvider>
);

export default SmallBossMachineOwnerPage;
